import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div :class="{inputsearch: true, 'inputsearch--value': modelValue}">
            <div class="inputsearch__input input input--text">
                <div class="input__widget">
                    <input type="text" :placeholder="placeholder" class="inputsearch__input input__input" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
                </div>

                <div class="inputsearch__buttons">
                    <i v-if="!modelValue" class="fa fa-search" />
                    <button v-if="modelValue" type="button" class="inputsearch__clear" @click="$emit('update:modelValue', null)"><i class="fa fa-times" /></button>
                </div>
            </div>
        </div>
    `,

    props: {
        modelValue: { type: String },
        placeholder: { type: String },
    },

    emits: [
        'update:modelValue',
    ],
});
